import {connect} from 'react-redux';

import Base from './Base';

const RouteStartHour = props => <Base {...props} id="route-start-hour" />;

const mapStateToProps = ({startHour: index}) => ({index});

export default connect(mapStateToProps)(RouteStartHour);
